import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { showModal } from 'appSrc/redux/actions';
import { PrimaryButton } from 'appSrc/components/UI';
import style from './styles/style.module.css';

import closeIcon from 'appSrc/assets/img/close.svg';

class ProductErrorModal  extends PureComponent {
    constructor( props ) {
        super( props );
    }
    render() {
        const { isOpen } = this.props;
        return (
            <ReactModal
            isOpen={ isOpen }
            contentLabel="Error Adding Product"
            onRequestClose={ this.props.closeModal }
            className={ `modal-popup ${ style.errorModal }` }
            overlayClassName='modal-overlay' >
                <div className={style.title}>
                    Error Adding Product
                </div>
                <div className={style.close}>
                    <img src={closeIcon} onClick={ this.props.closeModal } />
                </div>
                <div className={ style.modalContent }>
                    <p>It seems that you don&apos;t have any lists to add this product to.</p>
                    <div className={ style.buttonWrapper }>
                        <PrimaryButton
                        label="Create a list"
                        buttonStyle={ { height: '42px', lineHeight: '42px', width: '120px' } }
                        onClick={ () => { this.props.showModal( 'listCreationModal' ); this.props.closeModal(); } } />
                    </div>
                </div>
            </ReactModal>
        );
    }
}
ProductErrorModal.defaultProps = {
    isOpen: false,
};

const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        showModal: ( type ) => {
            dispatch( showModal( type ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ProductErrorModal );
